function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


//ADA Fixes
//Header Tab navigation fixes
$(document).ready(function () {
  if (!window.location.pathname.includes('search')){
$("#header-main-logo").on('keydown', function (event) { 
  if ((event.key === "Tab" || event.keyCode === 9) && !event.shiftKey) { 
    try { 
      
      $("#Search-In-Modal-1").focus();
    event.preventDefault(); 
   } catch (err) { 
    console.log(err); 
   }
  }
});
  }
 else if (window.location.pathname.includes('search')){
    $("#header-main-logo").on('keydown', function (event) { 
      if ((event.key === "Tab" || event.keyCode === 9) && !event.shiftKey) { 
        try { 
          event.preventDefault(); 
          $(".header__icon--account").focus();
       
       } catch (err) { 
        console.log(err); 
       }
      }
    });
    $(".header__icon--account").on('keydown', function (event) { 
      if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) { 
        try { 
          event.preventDefault(); 
          $("#header-main-logo").focus();
       
       } catch (err) { 
        console.log(err); 
       }
      }
    });
    $("h1").on('keydown', function (event) {
      if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
        event.preventDefault();
        $("#HeaderMenu-sale").attr('tabindex', '0').focus();

      }
    });
      }

  // Ada improvement - Tab from cart bubble to bras menu
$(document).on("keydown", "#cart-icon-bubble", function (event) {

  if (event.key === "Tab" && !event.shiftKey) {
    event.preventDefault();
    event.stopImmediatePropagation();

    $("#HeaderMenu-bras").attr("tabindex", "-1").focus();
  }
});

$(document).on("keydown", "#HeaderMenu-bras-shop-by-style", function (event) {
  if (event.key === "Tab" && event.shiftKey) {
    event.preventDefault();
    event.stopImmediatePropagation();

    $("#HeaderMenu-bras").focus();
  }
});

// Ada improvement - back Tab from schedule a fitting to clearance menu
$(document).on("keydown", "#schedule-a-fitting", function (event) {
  if (event.key === "Tab" && event.shiftKey) {
    event.preventDefault();
    event.stopImmediatePropagation();

    $("#HeaderMenu-clearance").focus();
  }
});

//ada improvement - Close clearance menu and focus main content when tabbing out of last item
(function () {
  const lastClearanceItem = document.getElementById(
    'HeaderMenu-clearance-everyday-layers'
  );

  if (!lastClearanceItem) return;

  lastClearanceItem.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || e.shiftKey) return;

    const details = this.closest('details');
    if (!details) return;

    e.preventDefault();

    // Close the menu cleanly
    details.removeAttribute('open');

    // Move focus to main content (banner / hero)
    const main = document.getElementById('MainContent');
    if (main) {
      main.focus();
    }
  });
})();


  if (!window.location.pathname.includes('loyalty')) {
  $("#HeaderMenu-sale-packs").on('keydown', function (event) {
  if ((event.key === "Tab" || event.keyCode === 9) && !event.shiftKey) {
    try {
      $("#MainContent").focus(); 
      event.preventDefault(); 
    }
    catch(err){
      console.log(err);
    }
   } 
  });
  }
  else if (window.location.pathname.includes('loyalty')){
    $("#HeaderMenu-sale-packs").on('keydown', function (event) {
      if (event.key === "Tab" || event.keyCode === 9) {
        try {
          $(".banner__media-full").focus(); 
          event.preventDefault(); 
        }
        catch(err){
          console.log(err);
        }
       } 
      });
      $(".banner__media-full").on('keydown', function (event) { 
        if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey){ 
          event.preventDefault(); 
          $("#HeaderMenu-sale").attr('tabindex', '0').focus();
        }
        });
  }
}); 


$(document).ready(function () {
  // commented out as per new requirements
  // $("#two_image_click_1").on('keydown', function (event) {
  //   if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
  //     event.preventDefault();
  //     $("#HeaderMenu-sale").attr('tabindex', '0').focus();

  //   }
  // });

  $("#two_image_click_1 img").attr('tabindex', 0);
  $("#two_image_click_2 img").attr('tabindex', 0);

  $("#Search-In-Modal-1").on('keydown', function (event) {
    if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
      event.preventDefault();
      $("#header-main-logo").focus();

    }
  });

  $("#HeaderMenu-bras").on('keydown', function (event) {
    if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
      event.preventDefault();
      $("#cart-icon-bubble").attr('tabindex', '0').focus();
    }
  });

  if (!window.location.pathname.includes('products') && !window.location.pathname.includes('og-about-us') && !window.location.pathname.includes('/')) {
    $("h1").on('keydown', function (event) {
      if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
        event.preventDefault();
        $("#HeaderMenu-sale").attr('tabindex', '0').focus();

      }
    });

  }
  else if (window.location.pathname.includes('products')) {
    $("slider-component .skip-to-content-link").on('keydown', function (event) {
      if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
        event.preventDefault();
        // Focus the last span element in the breadcrumbs navigation
        const breadcrumbs = document.querySelector('.Breadcrumbs.theme-breadcrumbs');
        if (breadcrumbs) {
          const lastSpan = breadcrumbs.querySelector('span[tabindex="0"]');
          if (lastSpan) {
            lastSpan.focus();
          } else {
            // Fallback to previous behavior if no span found
            $("#HeaderMenu-sale").attr('tabindex', '0').focus();
          }
        } else {
          // Fallback if breadcrumbs not found
          $("#HeaderMenu-sale").attr('tabindex', '0').focus();
        }
      }
    });
  }
  else if (window.location.pathname.includes('og-about-us')) {
    $("#schedule-a-fitting").on('keydown', function (event) {
      if ((event.key === "Tab" || event.keyCode === 9) && event.shiftKey) {
        event.preventDefault();
        $("#HeaderMenu-sale").attr('tabindex', '0').focus();

      }
    });
  }
  // $(".search-small-btn, search__button").on('keydown', function (event) {
  //   if (event.key === "Enter" || event.keyCode === 13) {
  //     event.preventDefault();
  //     $("h1:contains('Search Results')").attr('tabindex', '0').focus();

  //   }
  // });
});



$(document).ready(function() {
if (window.location.pathname.includes('customer-service')){
  $("strong").attr('tabindex', '0');
}
});


function updateAriaLabels() {

  const ratingReviews = document.querySelectorAll('.loox-rating');

  ratingReviews.forEach((item) => {
    const rating = item.getAttribute('data-rating');
    const raters = item.getAttribute('data-raters');
    
    if (rating && raters) {
      const ariaLabel = `Rating is ${rating} out of 5, based on ${raters} reviews`;
      item.setAttribute('aria-label', ariaLabel);
    } 
  });
  const ratingLabels = document.querySelectorAll('.loox-rating-label');

  ratingLabels.forEach((label) => {
    const parentRatingItem = label.closest('.loox-rating');

    if (parentRatingItem) {
      const rating = parentRatingItem.getAttribute('data-rating');
      const raters = parentRatingItem.getAttribute('data-raters');
      if (rating && raters) {
        const ariaLabelText = `Rating is ${rating} out of 5, based on ${raters} reviews`;
        label.setAttribute('aria-label', ariaLabelText);
        label.setAttribute('aria-hidden', 'false');
      } 
    } 
  });
}

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      updateAriaLabels(); 
    }
  }
});


observer.observe(document.body, { childList: true, subtree: true });



window.onload = function() {
  setTimeout(updateAriaLabels, 5);
};

$(document).ready(function () {

  const observerd = new MutationObserver(function () {
    $(".instafeed-fullname").off('click keydown').on("click keydown", handleInstaCaptionNavigation);
    $(".instafeed-post-image").off('click keydown').on("click keydown", handleInstaImageNavigation);
    $(".instafeed-new-layout-item").off('click keydown').on("click keydown", handleInstaFNameNavigation);
  });
  observerd.observe(document.body, { childList: true, subtree: true });
  $('.instafeed-caption').attr('tabindex', '0');
  $('#insta-feed').attr('tabindex', '0');
  $('.instafeed-post-image').attr('tabindex', '0');
  $('.instafeed-fullname').attr('tabindex', '0');

  function handleInstaCaptionNavigation(event) {

    event.preventDefault();


    if (event.key === "Tab" || event.keyCode === 9) {

      $('.instafeed-caption').attr('tabindex', '0');
      $('.instafeed-post-image').attr('tabindex', '0');
      event.preventDefault();

      $('.instafeed-post-image').focus();


    }
  }
  function handleInstaImageNavigation(event) {
    if (event.key === "Tab" || event.keyCode === 9) {
      $('.instafeed-post-image').attr('tabindex', '0');
      event.preventDefault();
      $('.instafeed-caption').focus();
    }
  }
  function handleInstaFNameNavigation(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      $('.instafeed-fullname').attr('tabindex', '0');
      console.log('enter key pressecd');
      event.preventDefault();
      setTimeout(function () { $('.instafeed-fullname').focus() }, 1000);
      $('.instafeed-fullname').focus();
    }
  }
});
document.addEventListener("DOMContentLoaded", function() {

  var pTags = document.querySelectorAll("p");

  
  pTags.forEach(function(pTag) {
     
      if (pTag.textContent.includes("Style")) {
         
          pTag.setAttribute("tabindex", "0");
      }
  });
});


$(document).ready(function() {
  $('.description ul li').attr('tabindex', '0');
});

$(document).ready(function() {
  $('.product__description ul li').attr('tabindex', '0');
});




$(document).ready(function () {
  $("#addfullset").on("keydown", function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      $(this).click();
    }
  });
});


$(document).ready(function () {
  $(".popup-close").on("keydown", function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      $(this).click();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const menuMap = {
    'HeaderMenu-bras': 'Bras drop down menu press tab to open',
    'HeaderMenu-underwear': 'Underwear drop down menu press tab to open',
    'HeaderMenu-new-arrivals': 'New Arrivals drop down menu press tab to open',
    'HeaderMenu-everyday-layers': 'Everyday Layers drop down menu press tab to open',
    'HeaderMenu-clearance': 'Clearance drop down menu press tab to open',
    'HeaderMenu-sale': 'Sale drop down menu press tab to open'
  };

  Object.entries(menuMap).forEach(([id, label]) => {
    const el = document.getElementById(id);

    if (el) {
      el.setAttribute('aria-label', label);
    } else {
      console.warn(`Element not found: ${id}`);
    }
  });
});




document.addEventListener('DOMContentLoaded', function () {
  const focusableElements = document.querySelectorAll('.ernpt_flx img[tabindex="0"], .ernpt_flx p[tabindex="0"]');
  
  document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && e.shiftKey) {
          handleBackwardTab(e, focusableElements);
      }
  });
  
  function handleBackwardTab(e, elements) {
      const focusedElement = document.activeElement;
      const focusableArray = Array.prototype.slice.call(elements);
      const currentIndex = focusableArray.indexOf(focusedElement);
      
      if (currentIndex > 0) {
          const previousElement = focusableArray[currentIndex - 1];
          previousElement.focus();
          e.preventDefault();
      }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const focusableElements = document.querySelectorAll('.loypt_flx .loypt_number[tabindex="0"], .loypt_flx .loypt_pts_heading[tabindex="0"], .loypt_flx p[tabindex="0"]');
  
  document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && e.shiftKey) {
          handleBackwardTab(e, focusableElements);
      }
  });
  
  function handleBackwardTab(e, elements) {
      const focusedElement = document.activeElement;
      const focusableArray = Array.prototype.slice.call(elements);
      const currentIndex = focusableArray.indexOf(focusedElement);
      
      if (currentIndex > 0) {
          const previousElement = focusableArray[currentIndex - 1];
          previousElement.focus();
          e.preventDefault();
      }
  }
  $(".loypt_pts_txt").on("keydown", function (event) {
    if (event.key === "Tab" || event.keyCode === 9) {
      $(".loypt_pts_txt").css('outline', 'none', '!important');
    }
  });
  $(".ernpt_txt").on("keydown", function (event) {
    if (event.key === "Tab" || event.keyCode === 9) {
      $(".ernpt_txt").css('outline', 'none', '!important');
    }
  });
});

//Mini cart backward tab navigation
document.addEventListener('keydown', function(event) {
  if (event.shiftKey && event.key === 'Tab') {
    const activeElement = document.activeElement;
    const cartItem = activeElement.closest('.cart-item');

    if (cartItem) {
      const focusableElements = cartItem.querySelectorAll('dt[tabindex="0"], dd[tabindex="0"], .price-tab[tabindex="0"]');
      const activeIndex = Array.from(focusableElements).indexOf(activeElement);

      if (activeIndex > 0) {
        focusableElements[activeIndex - 1].focus();
        event.preventDefault();
      }
    }
  }
});

$(".backToTopBtn").attr('aria-label', 'back to top');

  $(document).ready(function () {
    $("fieldset.js.product-form__input label").on("keydown", function (event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        $(this).click();
      }
    });
  });


$(document).ready(function () {
  if (window.location.pathname.includes('ccpa-opt-out')) {
    $("p").attr('tabindex', '0');
    }
});


$(document).ready(function () {
  if (window.location.pathname.includes('loyalty')) {
    $(".loypt_hd_txt").on("keydown", function (e) {
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        $(this).css('outline', 'none');
        $("#loyalty-header").focus();
      }
      else if (e.key === 'Tab' && !e.shiftKey) {
       
        $(this).css('outline', 'none');
      }
    });

    $(".loypt_hd_txt").on("blur", function () {
      $(this).css('outline', '');
    });
  }
});



$(document).ready(function () {
 
    $("#btn-browseset").on("keydown", function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        $(".pairs-heading").focus();
      }
    });

});
//Full set Popup size buttons ADA Fixes
$(document).ready(function () {
  function updateAriaLabels() {
    const sizeButtons = document.querySelectorAll(".product-info__size-swatch.popup-size");

    sizeButtons.forEach(sizeBtn => {
      sizeBtn.addEventListener('keydown', (event) => {
        if (event.keyCode === 32) {
          const activeElement = document.activeElement;
          activeElement.setAttribute('aria-checked', true);
        }
      });
    });
  }
    function setAriaLabelsForOutOfStockButtons() {
    $(".product-info__size-swatch.outstock-cup.popup-size").each(function() {
      const buttonValue = $(this).find('.option-positioning').text().trim();
      $(this).attr('aria-label', buttonValue + " out of stock");
    });
  }

  function setAriaLabelsForSelectedButtons() {
    const sizeInputs = document.querySelectorAll('.product-info__size-swatch.popup-size');
  
    sizeInputs.forEach(sizeBtn => {
      const defaultAriaLabel = sizeBtn.getAttribute('title');
  
      if (sizeBtn.classList.contains('active-size')) {
        sizeBtn.setAttribute('aria-label', `${defaultAriaLabel} ........checked`);
      } else {
        sizeBtn.setAttribute('aria-label', `${defaultAriaLabel} ........ Not checked`);
      }
    });
  }
  setAriaLabelsForSelectedButtons();
  setAriaLabelsForOutOfStockButtons();
  updateAriaLabels();

  const observer = new MutationObserver(function () {
    setAriaLabelsForSelectedButtons();
    setAriaLabelsForOutOfStockButtons();
    updateAriaLabels();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

//Full set Popup ADA Fixes

$(document).ready(function () {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
 

  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.id === "popup-qty-plus" || $(node).find("#popup-qty-plus").length) {
            const qtyPlusButtons = $("[id='popup-qty-plus']");
            qtyPlusButtons.each(function() {
              $(this).attr("tabindex", 0); 
              $(this).on("keypress", function (event) {
                if(event.key === "Enter" || event.keyCode === 13) {
                  console.log('Enter key pressed on popup-qty-plus');
                 
                  $(this).click(); 
 
                }
              
              });
            });
          }
          $("#addfullset").off("keydown").on("keydown", function (event) {
            if (event.key === "Enter" || event.keyCode === 13) {
              setTimeout(function() {
                $("#fulset-model-close").attr("tabindex", 0).focus(); 
              }, 100); 
            
            }
          });
          $("#popup-submit-btn").on("keydown", function (event) {
            if (event.key === "ArrowRight") {
              event.preventDefault();
            
                 setTimeout(function() {
                $("#fulset-model-close").attr("tabindex", 0).focus(); 
              }, 100); 
              $("#fulset-model-close").attr("tabindex", 0).focus(); 
            }
          });

          $("#popup-submit-btn, #popup-price, #full-set-popup-img, #fulset-model-close, .p-title, .color-label-popup, .popup-color, .complete-lbl-popup, .popup-size, #popup-qty-lbl, .popup-complete-qtyadjust, .popup_quantity_input").on("keydown", function (event) {
            if (event.key === "Tab") {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();

            }
          });
          $("#fulset-model-close").on("keydown", function (event) {
            if (event.key === "ArrowLeft") {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
            }
          });

        });
      }
    }
  };
  const observerr = new MutationObserver(callback);
  observerr.observe(targetNode, config);
});


//PDP Size input ADA Fixes

document.addEventListener('DOMContentLoaded', function () {
  const sizeLabel = document.querySelector('legend.form__label.size-lbl-pdp');
  const sizeInputs = document.querySelectorAll('fieldset.product-form__input input[name="Band Size"], input[name="Cup Size"], input[name="Size"], input[name="Title"], input[name="cup-size"]');
  const sizeLabelMap = new Map([...sizeInputs].map(input => [input, document.querySelector(`label[for="${input.id}"]`)]));
  var sizeFit = document.getElementById('open_popup_1');
  const BandSizeInputs = document.querySelectorAll('fieldset.product-form__input input[name="Band Size"]');
  const cupSizeInputs = document.querySelectorAll('fieldset.product-form__input input[name="Cup Size"]');
  const cupDashSizeInputs = document.querySelectorAll('fieldset.product-form__input input[name="cup-size"]');
  const commonSizeInputs = document.querySelectorAll('fieldset.product-form__input input[name="Size"]');
  const giftAmmountInputs = document.querySelectorAll('fieldset.product-form__input input[name="Title"]');
  

function updateAriaLabel(input) {
  if (input.classList.contains('disabled')) {
    let existingAriaLabel = input.getAttribute('aria-label') || input.getAttribute('value');
    input.setAttribute('aria-label', `${existingAriaLabel} Sold Out`);
  } else {
    input.setAttribute('aria-label', input.getAttribute('value'));
  }
}


sizeInputs.forEach(updateAriaLabel);


const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      updateAriaLabel(mutation.target);
    }
  });
});


const config = { attributes: true, attributeFilter: ['class'] };


sizeInputs.forEach(input => {
  observer.observe(input, config);
});
  sizeInputs.forEach(input => {
    if (input.classList.contains('disabled')) {
        input.addEventListener('click', function(event) {
            event.preventDefault();
            console.log("Disabled button clicked, but action prevented");
        });

        input.addEventListener('keydown', function(event) {
            if (event.key === "Enter" || event.key === " " || event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault();
                console.log("Disabled button activated by keyboard, but action prevented");
            }
        });  
    }
});

sizeInputs.forEach(input => {
      input.addEventListener('keydown', function(event) {
          if (event.key === "Enter") {
              event.preventDefault();
              
          }
      });  
});

  const applyOutline = (element, outline) => {
    const label = sizeLabelMap.get(element);
    if (label) {
      label.style.outline = outline;
    }
  };

  if (sizeLabel) {
    sizeLabel.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        if (sizeInputs.length > 0) {
          sizeInputs[0].focus();
          applyOutline(sizeInputs[0], '2px solid blue');
        }
      }
    });
  }

  $("legend:contains('Cup Size')").on('keydown', function(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      
      event.preventDefault();
      if (cupSizeInputs.length > 0) {
        cupSizeInputs[0].focus();
        applyOutline(cupSizeInputs[0], '2px solid blue');
      }
    } 
  });

  $("legend:contains('cup-size')").on('keydown', function(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      
      event.preventDefault();
      if (cupDashSizeInputs.length > 0) {
        cupDashSizeInputs[0].focus();
        applyOutline(cupDashSizeInputs[0], '2px solid blue');
      }
    } 
  });

  if (sizeFit) {
    sizeFit.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && event.shiftKey) {
        event.preventDefault();
        if (sizeInputs.length > 0) {
          sizeInputs[sizeInputs.length - 1].focus();
        }
      }
    });
  }

  if (BandSizeInputs.length > 0) {
    BandSizeInputs.forEach((input, index) => {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey && index === 0) {
          event.preventDefault();
   
            setTimeout(() => {
              event.preventDefault();
              $("legend:contains('Band Size')").focus();
            }, 100);
            $("legend:contains('Band Size')").focus();
          
        }
      });
    });
  }

  if (BandSizeInputs.length > 0) {
    BandSizeInputs.forEach(input => {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && !event.shiftKey && this === BandSizeInputs[BandSizeInputs.length - 1]) {
          event.preventDefault();
         
          setTimeout(function() {
            event.preventDefault();
            $("legend:contains('Cup Size')").focus();
            $("legend:contains('cup-size')").focus();
            
        }, 100);
        
        $("legend:contains('Cup Size')").focus();
        $("legend:contains('cup-size')").focus();
        
        }
      });
    });
  }
  if (cupSizeInputs.length > 0) {
    cupSizeInputs.forEach((input, index) => {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey && index === 0) {
          event.preventDefault();
   
            setTimeout(() => {
              event.preventDefault();
              $("legend:contains('Cup Size')").focus();
            }, 100);
            $("legend:contains('Cup Size')").focus();
          
        }
      });
    });
  }
  if (cupDashSizeInputs.length > 0) {
    cupDashSizeInputs.forEach((input, index) => {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey && index === 0) {
          event.preventDefault();
   
            setTimeout(() => {
              event.preventDefault();
              $("legend:contains('cup-size')").focus();
            }, 100);
            $("legend:contains('cup-size')").focus();
          
        }
      });
    });
  }
  if (giftAmmountInputs.length > 0) {
    giftAmmountInputs.forEach(input => {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && !event.shiftKey && this === giftAmmountInputs[giftAmmountInputs.length - 1]) {
          event.preventDefault();
         
          setTimeout(function() {
            event.preventDefault();
            $(".quantity__label").focus();
           
            
        }, 100);
        
        $(".quantity__label").focus();
       
        
        }
      });
    });
  }
  if (window.location.pathname.includes('gift-card')) {
  $(".quantity__label ").on('keydown', function(event) {
    if (event.key === 'Tab' && event.shiftKey) {
      
      event.preventDefault();
      if (giftAmmountInputs.length > 0) {
        giftAmmountInputs[giftAmmountInputs.length - 1].focus();
      }
    } 
  });
  }
  if (giftAmmountInputs.length > 0) {
    giftAmmountInputs.forEach((input, index) => {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey && index === 0) {
          event.preventDefault();
   
            setTimeout(() => {
              event.preventDefault();
              $("legend:contains('Title')").focus();
            }, 100);
            $("legend:contains('Title')").focus();
          
        }
        if (event.key === 'Enter') {
          input.click();
        }
      });
    });
  }
  $("legend:contains('Cup Size')").on('keydown', function(event) {
    if (event.key === 'Tab' && event.shiftKey) {
      
      event.preventDefault();
      if (BandSizeInputs.length > 0) {
        BandSizeInputs[BandSizeInputs.length - 1].focus();
      }
    } 
  });

  $("legend:contains('cup-size')").on('keydown', function(event) {
    if (event.key === 'Tab' && event.shiftKey) {
      
      event.preventDefault();
      if (BandSizeInputs.length > 0) {
        BandSizeInputs[BandSizeInputs.length - 1].focus();
      }
    } 
  });

  if (commonSizeInputs.length > 0) {
    commonSizeInputs.forEach((input, index) => {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey && index === 0) {
          event.preventDefault();
   
            setTimeout(() => {
              event.preventDefault();
              $("legend:contains('Size')").focus();
            }, 100);
            $("legend:contains('Size')").focus();
          
        }
      });
    });
  }
  sizeInputs.forEach(input => {
    input.addEventListener('focus', () => {
      applyOutline(input, '2px solid blue');
    });

    input.addEventListener('blur', () => {
      applyOutline(input, 'none');
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        event.preventDefault();
        focusNextElement(event.target, sizeInputs, event.shiftKey, sizeFit, BandSizeInputs, cupSizeInputs, giftAmmountInputs, cupDashSizeInputs, commonSizeInputs, sizeLabel);
      }
    });
  });
});



function focusNextElement(currentElement, elementsArray, goBackwards = false, elementAfterList, elementBeforeList) {
  let currentIndex = Array.prototype.indexOf.call(elementsArray, currentElement);
  let nextIndex;

  if (!goBackwards) {
    nextIndex = (currentIndex + 1) % elementsArray.length;
    if (currentIndex === elementsArray.length - 1) {
      if (elementAfterList) {
        elementAfterList.focus();
        return;
      }
    }
  } else {
    nextIndex = (currentIndex - 1 + elementsArray.length) % elementsArray.length;
    if (currentIndex === 0) {
      if (elementBeforeList) {
        elementBeforeList.focus();
        return;
      }
    }
  }

  elementsArray[nextIndex].focus();
  

  applyOutline(elementsArray[nextIndex], '2px solid blue');

  
  applyOutline(currentElement, 'none');
}

function applyOutline(element, outline) {
  const label = document.querySelector(`label[for="${element.id}"]`);
  if (label) {
    label.style.outline = outline;
  }
}

//fullset product size buttons ADA Fixes
document.addEventListener('DOMContentLoaded', function () {
 
  function updateSizeButtons() {
      const fullSetSizeBtns = document.querySelectorAll(".product-info__size-swatch.btn-complete-size");
      fullSetSizeBtns.forEach(btn => {
        setTimeout(() => {
          btn.setAttribute('role', 'radio');
          btn.setAttribute('aria-checked', false);
          btn.removeAttribute('disabled');
        }, 300);
      });
 

  }


  function updateAriaLabelsOnCS() {
    const sizeButtons = document.querySelectorAll(".product-info__size-swatch.btn-complete-size");
    const outOfStockButtons = document.querySelectorAll(".outstock-band, .outstock-cup");

    sizeButtons.forEach(sizeBtn => {
      sizeBtn.addEventListener('keydown', (event) => {
        if (event.keyCode === 32) {
          const activeElement = document.activeElement;
          activeElement.setAttribute('aria-checked', true);
        }
      });
    });

    outOfStockButtons.forEach(outsizeBtn => {
      outsizeBtn.style.pointerEvents = 'none';
      outsizeBtn.addEventListener('keydown', function(event) {
                      if (event.key === "Enter" || event.key === " " || event.keyCode === 13 || event.keyCode === 32) {
                          event.preventDefault();
                          console.log("Disabled button activated by keyboard, but action prevented");
                      }
                  });  
    });
  }


  function setAriaLabelsForSelectedButtonsOnCS() {
    const bandsizeInputsBtns = document.querySelectorAll('.product-info__size-swatch.product-info-band-size.btn-complete-size');
    const cupsizeInputsBtns = document.querySelectorAll('.product-info__size-swatch.product-info-cup-size.btn-complete-size');
    bandsizeInputsBtns.forEach(bandSizeBtn => {
      const defaultAriaLabel = bandSizeBtn.getAttribute('title');
  
      if (bandSizeBtn.classList.contains('active-size')) {
        bandSizeBtn.setAttribute('aria-label', `${defaultAriaLabel} ........checked`);
      } 
      else {
        bandSizeBtn.setAttribute('aria-label', `${defaultAriaLabel} ........ Not checked`);
      }
        if (bandSizeBtn.classList.contains('outstock-band')) {
        bandSizeBtn.setAttribute('aria-label', `${defaultAriaLabel} ........out of stock`);
      } 
      if (bandSizeBtn.classList.contains('outstock-cup')) {
        bandSizeBtn.setAttribute('aria-label', `${defaultAriaLabel} ........out of stock`);
      } 
    });

    cupsizeInputsBtns.forEach(cupSizeBtn => {
      const defaultAriaLabelCup = cupSizeBtn.getAttribute('title');
  
      if (cupSizeBtn.classList.contains('active-cup')) {
        cupSizeBtn.setAttribute('aria-label', `${defaultAriaLabelCup} ........checked`);
      } 
    
      else {
        cupSizeBtn.setAttribute('aria-label', `${defaultAriaLabelCup} ........ Not checked`);
      }
      if (cupSizeBtn.classList.contains('outstock-cup')) {
        cupSizeBtn.setAttribute('aria-label', `${defaultAriaLabelCup} ........out of stock`);
      } 
    });
  }

  updateSizeButtons();
 
   updateAriaLabelsOnCS();
  
  setAriaLabelsForSelectedButtonsOnCS();
 
  const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
         
            updateSizeButtons();
           
             updateAriaLabelsOnCS();
            
            setAriaLabelsForSelectedButtonsOnCS();
           
          }
      });
     
  });

 
  const targetNode = document.querySelector('.product-info__variants');

  
  const config = { 
      childList: true, 
      subtree: true, 
      attributes: true, 
      attributeFilter: ['class', 'disabled'] 
  };

 
  if (targetNode) {
      observer.observe(targetNode, config);
  }
});

//Size chart Fix
document.addEventListener("DOMContentLoaded", function() {
  const modalContents = document.querySelectorAll('.modal-content');
  modalContents.forEach(modalContent => {
      if (modalContent.querySelector('.panties')) {
          modalContent.classList.add('has-panties');
      }
  });
});

// sortby ADA fix
document.addEventListener('DOMContentLoaded', () => {
  const SORT_ID = 'SortBy';

  const attachEventListeners = (selectElement) => {
    //  validation: element exists
    if (!selectElement) return;

    //  prevent duplicate listeners
    if (selectElement.dataset.listenersAttached === 'true') return;
    selectElement.dataset.listenersAttached = 'true';

    selectElement.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        // intentionally left blank (your logic here if needed)
      }
    });

    selectElement.addEventListener('change', () => {
      //  validation: jQuery exists
      if (typeof window.jQuery === 'undefined') return;

      $(document).on('keydown.sortTab', function (event) {
        if (event.key === 'Tab' || event.keyCode === 9) {
          const $label = $('.facet-filters__label');

          //  validation: element exists
          if ($label.length) {
            $label.attr('tabindex', 0).focus();
          }

          $(document).off('keydown.sortTab');
        }
      });
    });
  };

  //  initial attach
  attachEventListeners(document.getElementById(SORT_ID));

  //  observe only if element may be re-rendered (Shopify filters)
  const observer = new MutationObserver(() => {
    const newSortBySelect = document.getElementById(SORT_ID);
    attachEventListeners(newSortBySelect);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


//Schedule a fitting page ADA Fixes
let enterTracking = false;
$(document).ready(function(){
  if (window.location.pathname.includes('were-here-to-support-you-in-all-right-ways')) {
  $(".telephone").on('keydown', function(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      console.log("tab pressed");
      enterTracking = true;
    } 
    if(enterTracking){
      if (event.key === 'Tab' || event.keyCode === 9) {
        console.log("tab pressed");
        event.preventDefault();
        $("#fitting-paragraph-top").focus();
        enterTracking = false;
      } 
    }
  });


    $("#fitting-paragraph").on('keydown', function(event) {
      if (event.key === 'Tab' || event.keyCode === 9) {
        console.log("tab pressed");
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
          $(".icon-close").focus();
      

      } 
    });
    $(".icon-close").on('keydown', function(event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        console.log("tab pressed");
        event.preventDefault();
          $(this).click();
          $(".telephone").focus();

      } 
    });

    $(".previous").on("keydown", function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        $(this).click();
        $(".store-form").focus();
      }
    });
  }
});


$("#afterpay-modal-close-button").on("keydown", function (event) {
  if (event.key === "Enter") {
    $(this).click();
  }
});

//Color swatch buttons ADA Fixes
// document.addEventListener('DOMContentLoaded', () => {

//   const observeMutations = () => {
//     const observer = new MutationObserver(mutations => {
//       mutations.forEach(mutation => {
//         if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//           mutation.addedNodes.forEach(node => {
//             if (node.nodeType === Node.ELEMENT_NODE) {
//               const colorSwatchButtons = node.querySelectorAll(".outer-circle");

//               colorSwatchButtons.forEach(colorBtn => {
//                 colorBtn.setAttribute('tabindex', '0');
//                 colorBtn.addEventListener('keydown', (event) => {
//                   if (event.keyCode === 13) {
//                     const activeElement = document.activeElement;
//                     activeElement.setAttribute('aria-checked', true);
//                     colorBtn.click();
//                   }
//                 });
//               });
//             }
//           });
//         }
//       });
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
//   };


//   const colorSwatchButtons = document.querySelectorAll(".outer-circle");

//   colorSwatchButtons.forEach(colorBtn => {
//     colorBtn.setAttribute('tabindex', '0');
//     colorBtn.addEventListener('keydown', (event) => {
//       if (event.keyCode === 13) {
//         const activeElement = document.activeElement;
//         activeElement.setAttribute('aria-checked', true);
//         colorBtn.click();
//       }
//     });
//   });


//   observeMutations();

// });

document.addEventListener('DOMContentLoaded', () => {

 
function addAriaLabelledby() {
  const textareas = document.querySelectorAll('textarea[name="g-recaptcha-response"], textarea[name="h-captcha-response"]');
  textareas.forEach(textarea => {
      textarea.setAttribute('aria-labelledby', 'hcaptcha');
  });
}


addAriaLabelledby();


const observer = new MutationObserver(() => {
  addAriaLabelledby();
});


observer.observe(document.body, { childList: true, subtree: true });



});
document.addEventListener('DOMContentLoaded', () => {

function labelEmptyButtons() {
  const buttons = document.querySelectorAll('.shopify-payment-button__button--unbranded, .shopify-payment-button__more-options');
  buttons.forEach(button => {
      button.setAttribute('aria-label', 'Payment button'); 
  });

const needsclickDivs = document.querySelectorAll('div.needsclick.kl-private-reset-css-Xuajs1[style*="position: relative;"][style*="width: 100%;"][style*="height: 100%;"]');
needsclickDivs.forEach(needsclickDiv => {
  const img = needsclickDiv.querySelector('img'); 
  if (img) {
    img.setAttribute('aria-label', 'Picture'); 
  }
});

}


labelEmptyButtons();


const observer = new MutationObserver(() => {
  labelEmptyButtons();
});


observer.observe(document.body, { childList: true, subtree: true });

});
//Filtering - after removing fliters then focus to filters secion again
  let focusAfterTab = false;
  
  let preventFocusTwice = false;
  $(document).ready(function () {
    let focusAfterTab = false;
  
    let preventFocusTwice = false;
  
    const setFocusOnFilterByHeading = () => {
        if (!preventFocusTwice) {
            preventFocusTwice = true;
            $('#verticalTitle').focus();
            setTimeout(() => {
                preventFocusTwice = false;
            }, 3000); 
        }
    };
  
    const handleFilterRemove = (event) => {
        if (event.type === 'click' || (event.type === 'keydown' && (event.key === 'Enter' || event.keyCode === 13))) {
            focusAfterTab = true;
            setTimeout(setFocusOnFilterByHeading, 4000);
        }
    };
  
    const handleTabKey = (event) => {
        if (event.key === 'Tab' || event.keyCode === 9) {
            if (focusAfterTab) {
                event.preventDefault();
                focusAfterTab = false;
                setFocusOnFilterByHeading();
            }
        }
    };
  
    const observer = new MutationObserver(function () {
        $(".active-facets__button, .active-facets__button-remove").off('click keydown').on("click keydown", handleFilterRemove);
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  
    $(".active-facets__button, .active-facets__button-remove").on("click keydown", handleFilterRemove);
    $(document).on('keydown', handleTabKey);
  });
//ADA Fixes ended
// Quick Shop Btn
function initQuickBuyComponent() {
  const productCards = document.querySelectorAll('.card-wrapper');

  productCards.forEach(card => {
    const quickShopButton = card.querySelector('.quick-add');

    if (!quickShopButton) return;

    // // Show on focusin
    // card.addEventListener('focusin', function() {
    //   quickShopButton.style.display = 'block';
    //   quickShopButton.setAttribute('tabindex', '0');
      
    // });

    // Show on hover
    card.addEventListener('mouseenter', function() {
      quickShopButton.style.display = 'block';      
      quickShopButton.setAttribute('tabindex', '0');
      
    });

    // Hide on mouse leave (optional)
    card.addEventListener('mouseleave', function() {
      quickShopButton.style.display = 'none';

    });

    // // Hide on blur (optional)
    // card.addEventListener('focusout', function() {
    //   quickShopButton.style.display = 'none';

    // });
  });
};
document.addEventListener("DOMContentLoaded", function () {
  initQuickBuyComponent();
});
$('.card__content').on('click', function(event) {
  // If the click is inside the .quick-add area, do nothing
  if ($(event.target).closest('.quick-add').length > 0) {
    return; // Don't redirect
  }

  // Otherwise, go to the product page
  const link = $(this).find('a.full-unstyled-link').attr('href');
  if (link) {
    window.location.href = link;
  }
});

document.addEventListener("click", function (e) {
  const content = e.target.matches(".card__content");
  if (content){
    const card = e.target.closest(".card-wrapper.product-card-wrapper.underline-links-hover");
      if (!card)
      {
        return;
      } 

      if (card) {
            const link = card.getAttribute("data-link");
            if (link) {
              window.location.href = link;
            }
        }
  } 
  
});


 // Silences Loox Rating links if no reviews exist - Accessibility Fix
const silenceEmptyRatings = () => {
  document.querySelectorAll('.loox-rating.loox-widget').forEach(widget => {
    // Check if rating data is missing or empty
    const rating = widget.getAttribute('data-rating');
    const raters = widget.getAttribute('data-raters');
    const parentLink = widget.closest('a[href="#looxReviews"]');

    if (parentLink && (!rating || rating === "" || raters === "0")) {
      // 1. Standard Accessibility Silencing
      parentLink.setAttribute('aria-hidden', 'true');
      parentLink.setAttribute('tabindex', '-1');
      parentLink.removeAttribute('aria-label');
      
      // 2. UserWay Specific Overrides
      parentLink.setAttribute('data-uw-rm-brl', 'PR'); // Mark as Presentational
      parentLink.setAttribute('data-uw-rm-empty-ctrl', 'true');
      
      // 3. Optional: Visually hide if empty
      parentLink.style.display = 'none'; 
    }
  });
};

// 1. Run on initial load
document.addEventListener('DOMContentLoaded', silenceEmptyRatings);

// 2. Observe for Loox AJAX loading (Loox often injects ratings late)
const looxObserver = new MutationObserver(() => silenceEmptyRatings());
looxObserver.observe(document.body, { childList: true, subtree: true });


// Accessibility improvement for Quantity input buttons - PDP Cart
document.addEventListener('DOMContentLoaded', function () {
  const quantityWrappers = document.querySelectorAll('quantity-input');

  quantityWrappers.forEach(wrapper => {
    const input = wrapper.querySelector('.quantity__input');
    const buttons = wrapper.querySelectorAll('.quantity__button');

    buttons.forEach(button => {
      button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();

          // Trigger native click
          button.click();

          // Move focus to input so SR reads updated value
          setTimeout(() => {
            input.focus();
            input.setSelectionRange(input.value.length, input.value.length);
          }, 50);
        }
      });
    });
  });
});

// Accessibility fix for heading on Rich Text sections
document.addEventListener('DOMContentLoaded', function () {
  const heading = document.querySelector(
    '.rich-text__text h3'
  );

  if (heading) {
    heading.setAttribute('tabindex', '0');
  }
});

// Accessibility fix to focus mini cart title after adding to cart
document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.querySelector('.product-form__submit');
  if (!addToCartBtn) return;
 
  addToCartBtn.addEventListener('click', waitForMiniCart);
  addToCartBtn.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      waitForMiniCart();
    }
  });
 
  function waitForMiniCart() {
    let attempts = 0;
    const maxAttempts = 100; // ~5 seconds
 
    const focusInterval = setInterval(() => {
      attempts++;
 
      const cartTitle = document.querySelector(
        '.amp-cart__header-title'
      );
 
      if (
        cartTitle &&
        cartTitle.offsetParent !== null &&
        window.getComputedStyle(cartTitle).visibility !== 'hidden'
      ) {
        // Make sure it is programmatically focusable
        if (!cartTitle.hasAttribute('tabindex')) {
          cartTitle.setAttribute('tabindex', '-1');
        }
 
        cartTitle.focus();
        clearInterval(focusInterval);
      }
 
      if (attempts >= maxAttempts) {
        clearInterval(focusInterval);
      }
    }, 50);
  }
});

// Accessibility fix for "More payment options" button label
  (function() {
    const targetId = 'more-payment-options-link';
    const desiredLabel = 'More payment options';

    function updateLabel() {
      const btn = document.getElementById(targetId);
      if (btn && btn.getAttribute('aria-label') !== desiredLabel) {
        btn.setAttribute('aria-label', desiredLabel);
        // Optional: Also update title to match
        btn.setAttribute('title', desiredLabel);
      }
    }

    // 1. Initial check after load (your working method)
    window.addEventListener('load', () => setTimeout(updateLabel, 2500));

    // 2. Continuous watch (stops Shopify from reverting it later)
    const observer = new MutationObserver((mutations) => {
      updateLabel();
    });

    observer.observe(document.body, {
      childList: true, 
      subtree: true, 
      attributes: true,
      attributeFilter: ['aria-label'] 
    });
  })();

  // Accessibility improvement for Facet summary elements once selected the option in Collection sidebar
const fixFacetAccessibility = () => {
  const facetSummaries = document.querySelectorAll('.facets__summary');

  facetSummaries.forEach((summary, index) => {
    const parentDetails = summary.closest('details');
    // The main span containing "Price", "Color", etc.
    const labelSpan = summary.querySelector('span'); 
    // The span containing the number "(0)" - usually absent in Price filter
    const countSpan = summary.querySelector('.facets__selected'); 
    
    if (!parentDetails || !labelSpan) return;

    // Get the base text (e.g., "Price" or "Color")
    const labelText = labelSpan.childNodes[0].textContent.trim(); 
    let accessibleName = labelText;

    // ONLY append "X selected" if a count span actually exists in the HTML
    if (countSpan) {
       let countText = countSpan.textContent.replace(/[()]/g, '').trim();
       accessibleName = `${labelText} ${countText} selected`;
    }

    // Apply attributes
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-label', accessibleName);
    summary.setAttribute('aria-expanded', parentDetails.hasAttribute('open') ? 'true' : 'false');
    
    // Cleanup any old attributes that might interfere
    summary.removeAttribute('aria-labelledby');
  });
};

// Observer for AJAX filter updates
const facetWrapper = document.getElementById('main-collection-filters');
if (facetWrapper) {
  const observer = new MutationObserver(() => fixFacetAccessibility());
  observer.observe(facetWrapper, { childList: true, subtree: true });
}

// Initial run on load
document.addEventListener('DOMContentLoaded', fixFacetAccessibility);
// Mini cart open on click and enter key press
const cartBtn = document.getElementById('cart-icon-bubble');

cartBtn.addEventListener('keydown', function (e) {
  if (e.key === 'Enter' || e.key === ' ') {
    const cart = document.querySelector('.amp-cart');

    if (cart) {
      cart.classList.add('amp-cart--open');
    }
  }
});


document.getElementById('cart-icon-bubble').addEventListener('click', function () {
  const cart = document.querySelector('.amp-cart');

  if (cart) {
    cart.classList.add('amp-cart--open');
  }
});


// Mini cart close on click and enter key press
document.addEventListener('click', function (e) {
  if (e.target.closest('.amp-cart__header-close-button')) {
    document.querySelector('.amp-cart')?.classList.remove('amp-cart--open');
  }
});

document.addEventListener('keydown', function (e) {
  if ((e.key === 'Enter' || e.key === ' ') &&
      document.activeElement.closest('.amp-cart__header-close-button')) {
    
    document.querySelector('.amp-cart')?.classList.remove('amp-cart--open');
  }
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.amp-cart-drawer__overlay')) {
    document.querySelector('.amp-cart')?.classList.remove('amp-cart--open');
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelector('.amp-cart')?.classList.remove('amp-cart--open');
  }
});


// Focus on cart title when mini cart opens after add to cart
const waitForTitleAndFocus = () => {
  const interval = setInterval(() => {
    const cart = document.querySelector('.amp-cart');
    const title = document.querySelector('.amp-cart__header-title');
    const cartCount = document.querySelector('.amp-cart__header-cart-count');

    if (cart?.classList.contains('amp-cart--open') && title) {
      // make focusable
      title.setAttribute('tabindex', '0');
      cartCount.setAttribute('tabindex', '0');

      // focus
      title.focus();

      clearInterval(interval);
    }
  }, 50); // keep checking until ready
};

document.addEventListener('click', function (e) {
  if (e.target.closest('[name="add"]')) {
    setTimeout(() => {
      waitForTitleAndFocus();
    }, 200);
  }
});

document.addEventListener('keydown', function (e) {
  if ((e.key === 'Enter') && document.activeElement.closest('[name="add"]')) {
    setTimeout(() => {
      waitForTitleAndFocus();
    }, 200);
  }
});

// Loox reviews - hide if empty

document.addEventListener('DOMContentLoaded', function () {

  const looxLink = document.querySelector('a[href="#looxReviews"]');
  const looxWidget = looxLink?.querySelector('.loox-rating');

  if (!looxLink || !looxWidget) return;

  function checkLooxEmpty() {
    const isEmpty =
      !looxWidget.innerText.trim() &&
      !looxWidget.getAttribute('data-rating') &&
      !looxWidget.getAttribute('data-raters');

    if (isEmpty) {
      // Hide visually
      looxLink.style.display = 'none';

      // Hide from screen readers
      looxLink.setAttribute('aria-hidden', 'true');

      // Prevent focus
      looxLink.setAttribute('tabindex', '-1');
    } else {
      // Restore if content exists
      looxLink.style.display = '';
      looxLink.removeAttribute('aria-hidden');
      looxLink.removeAttribute('tabindex');
    }
  }

  // Initial check
  checkLooxEmpty();

  // Observe dynamic updates (Loox loads async)
  const observer = new MutationObserver(checkLooxEmpty);
  observer.observe(looxWidget, {
    childList: true,
    subtree: true,
    attributes: true
  });

});

// Short description - make focusable
document.addEventListener('DOMContentLoaded', function () {
  const shortDescP = document.querySelector('.short-des-0-pd p');

  if (shortDescP) {
    shortDescP.setAttribute('tabindex', '0');
  }
});

// Screen reader announcement for product cards on Enter key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Enter' || event.keyCode === 13) {
    const card = event.target.closest('.card-wrapper.product-card-wrapper');
    if (!card) return;

    // Do not trigger if focus is on quick shop buttons
    if (event.target.closest('.quick-add')) return;

    const productName = card.getAttribute('data-product-title');
    if (productName) {
      let announcer = document.getElementById('sr-card-desc-announcer');
      if (!announcer) {
        announcer = document.createElement('div');
        announcer.id = 'sr-card-desc-announcer';
        announcer.setAttribute('aria-live', 'assertive');
        announcer.style.position = 'absolute';
        announcer.style.left = '-9999px';
        announcer.style.width = '1px';
        announcer.style.height = '1px';
        announcer.style.overflow = 'hidden';
        document.body.appendChild(announcer);
      }
      
      // Clear first to allow repeating, then update text
      announcer.textContent = '';
      setTimeout(() => {
        announcer.textContent = 'View details for ' + productName;
      }, 50);
    }

    // Handle redirection for the image
    if (event.target.classList.contains('motion-reduce')) {
      const url = event.target.getAttribute('data-url');
      if (url) {
        // Wait a small amount for the screen reader to grab the text, then redirect
        setTimeout(() => {
          window.location.href = url;
        }, 100);
      }
    }

     // Handle redirection for the image
    if (event.target.classList.contains('full-unstyled-link')) {
      const url = event.target.getAttribute('data-url');
      if (url) {
        // Wait a small amount for the screen reader to grab the text, then redirect
        setTimeout(() => {
          window.location.href = url;
        }, 100);
      }
    }
    
  }
});

// Hide secondary images in product thumbnails from screen readers and keyboard navigation to prevent confusion, as they are decorative and not meant to be focused on or read by assistive technologies.
(function () {
 
  function hideSecondaryImages() {
 
    const secondaryImages = document.querySelectorAll(
      '.card__media .media .motion-reduce:not(:first-child)'
    );
 
    secondaryImages.forEach(img => {
 
      // Hide from screen readers
      img.setAttribute('aria-hidden', 'true');
 
      // Decorative image → empty alt
      img.setAttribute('alt', '');
 
      // Prevent accidental focus (rare but safe)
      img.setAttribute('tabindex', '-1');
 
    });
 
  }
 
  // Run on load
  window.addEventListener('load', hideSecondaryImages);
 
  // Run after AJAX / Boost / infinite scroll / filters
  const observer = new MutationObserver(hideSecondaryImages);
 
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
 
})();
